import styled from 'styled-components';
import { spacing } from '@izettle/otto';
import { IconButtonColorCss } from './variants.js';

const sizes = {
  small: "20px",
  medium: "24px",
  large: "28px"
};
const FOCUS_BORDER_WIDTH = "1px";
const getIconButtonSize = _ref => {
  let {
    size = "medium"
  } = _ref;
  return sizes[size];
};
const getVariant = _ref2 => {
  let {
    variant = "primary"
  } = _ref2;
  return IconButtonColorCss[variant];
};
const IconButtonBase = /*#__PURE__*/styled.button.attrs(_ref3 => {
  let {
    title
  } = _ref3;
  return {
    "aria-label": title,
    type: "button"
  };
}).withConfig({
  displayName: "styles__IconButtonBase",
  componentId: "zettle__sc-otg9e7-0"
})(["position:relative;font-size:", ";padding:", ";line-height:1;cursor:pointer;border:", " solid;border-radius:100%;transition-duration:0.1s;transition-timing-function:ease;transition-property:background-color,border-color,color;background-color:transparent;border-color:transparent;", ";&:focus::before{content:\"\";position:absolute;top:-3px;right:-3px;bottom:-3px;left:-3px;border:1px solid black;border-radius:50%;}&:focus{outline:none;}&:disabled{cursor:not-allowed;background-color:transparent;border-color:transparent;}height:unset;-webkit-font-smoothing:unset;"], getIconButtonSize, spacing.tiny, FOCUS_BORDER_WIDTH, getVariant);
const IconMouseClickFocusRemover = /*#__PURE__*/styled.div.attrs({
  tabIndex: -1
}).withConfig({
  displayName: "styles__IconMouseClickFocusRemover",
  componentId: "zettle__sc-otg9e7-1"
})(["height:calc(100% + ", " * 2);width:calc(100% + ", " * 2);top:-", ";left:-", ";position:absolute;z-index:1;border-radius:inherit;&:focus{outline:none;&::-moz-focus-inner{border:0;}}"], FOCUS_BORDER_WIDTH, FOCUS_BORDER_WIDTH, FOCUS_BORDER_WIDTH, FOCUS_BORDER_WIDTH);

export { IconButtonBase, IconMouseClickFocusRemover, sizes };
//# sourceMappingURL=index.js.map
